import React, { Component } from 'react'

// redux
import { connect } from 'react-redux'
import roleActions from '../../redux/qbrole/actions'

// ui
import { Table, Tag } from 'antd'
import Button from '../../components/uielements/button'

// render table 
const columns = [
    {
        align: 'center',
        title: 'Tên quyền',
        key: 'role_name',
        render: object => <div style={{minWidth: 150}}>{object.role_name}</div>
    },
    {
        align: 'center',
        title: "Số lượng quyền",
        key: 'listActions',
        render: object => {
            let list_actions = object.action_ids ? object.action_ids : []
            list_actions = [
                ...list_actions,
            ]
            return (
                <div>
                    {
                        // list_actions.map((action, index) => {
                        //     return (
                        //         <Tag key={index} color="blue" style={{margin: 5}}>
                        //             {
                        //                 action
                        //             }
                        //         </Tag>
                        //     )
                        // })
                        list_actions.length
                    }
                </div>
            )

        }
    },
    {
        align: 'center',
        title: 'Hành động',
        key: 'action',
        render: object => {
            return (
                <div style={{minWidth: 150}}>
                    <Button
                        size="small"
                        type="link"
                        style={{
                            marginRight: 5,
                            color: 'black',
                            backgroundColor: '#b3e6ff',
                        }}
                        onClick={object.onDetail}
                    >
                        Chi tiết
                    </Button>
                    <Button
                        size="small"
                        type="link"
                        style={{
                            marginRight: 5,
                            color: 'black',
                            backgroundColor: '#ff9999',
                        }}
                        onClick={object.onDelete}
                    >
                        Xoá
                    </Button>
                </div>
            )
        },
    },
]

class ListRoles extends Component {
    _onShowDetail = role => {
        this.props.updateCurrentRole(role)
        this.props.showDetailModal()
    }

    _onDelete = role => {
        this.props.updateCurrentRole(role)
        this.props.showDeleteConfirmModal()
    }

    render() {
        const { roles } = this.props

        // add event
        let complete_roles = []
        roles.forEach(role => {
            let complete_role = {
                ...role,
                ...{
                    onDetail: () => this._onShowDetail(role),
                    onDelete: () => this._onDelete(role)
                }
            }
            complete_roles.push(complete_role)
        });

        return (
            <div className="ListRoles">
                <Table
                    columns={columns}
                    dataSource={complete_roles}
                    bordered
                    pagination={false}
                />
            </div>
        )
    }
}

const mapStateToProps = state => {
    console.log("state - role : ", state)
    return {
        roles: state.qbrole.roles
    }
}

const mapDispatchToProps = dispatch => {
    return {
        showDetailModal: () => {
            dispatch(roleActions.action.showModalCurrentRoleInfo())
        },
        showDeleteConfirmModal: () => {
            dispatch(roleActions.action.showModalConfirmDeleteRole())
        },
        updateCurrentRole: (role) => {
            dispatch(roleActions.action.updateCurrentRole(role))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ListRoles)